$(function () {
    function pushQuoteGenerateLeadEvent(sku, region, country, dealerId, dealerName, contactMethodPreference) {
        if (!sku || !country || !dealerId || !dealerName || !contactMethodPreference) {
            return;
        }

        dataLayer.push({ event: 'gtm.clear' });
        dataLayer.push({
            'event': 'generate_lead',
            'form_id': 'request_a_quote',
            'product_interest': sku,
            'region': region ?? '',
            'country': country,
            'dealer_id': dealerId,
            'dealer_name': dealerName,
            'contact_method_preference': contactMethodPreference === '1' ? 'phone' : 'email',
        });
    }

    function trackQuoteRequestFormSubmit() {
        var mainCompontentSku = $('#quote_maincomponent').val();
        var region = $('#quote_region').val();
        var country = $('#quote_country').val();
        var dealerId = $('#quote_dealerid').val();
        var dealerName = $('#quote_dealername').val();
        var contactMethodPreference = $('#quote_preferredcontactmethod').val();

        pushQuoteGenerateLeadEvent(mainCompontentSku, region, country, dealerId, dealerName, contactMethodPreference);
    }

    window.trackQuoteRequestFormSubmit = trackQuoteRequestFormSubmit;
});